module.exports = __webpack_public_path__ + "static/media/delivery-img.301a2e79.png";